// User-facing "daily limit reached" copy for the homepage gates (M3).
// Three audiences: anonymous, paid-but-not-premium, and premium (no upsell).

function pluralize(n, singular, plural) {
    return n === 1 ? singular : plural;
}

/**
 * @param {'quick'|'practice'} kind
 * @param {boolean} isLoggedIn
 * @param {boolean} isPremium
 * @param {number} limit  the user's daily cap for this activity
 */
export function limitReachedMessage({ kind, isLoggedIn, isPremium, limit }) {
    const longNoun = kind === 'quick'
        ? pluralize(limit, 'quick test', 'quick tests')
        : pluralize(limit, 'Practice Question Set', 'Practice Question Sets');
    const shortNoun = kind === 'quick'
        ? pluralize(limit, 'test', 'tests')
        : pluralize(limit, 'Practice Question Set', 'Practice Question Sets');
    const moreNoun = kind === 'quick' ? 'tests' : 'Practice Question Sets';

    if (!isLoggedIn) {
        return `You've reached the max limit of ${limit} ${longNoun} today without login. `
            + `Take another ${limit} ${shortNoun} tomorrow, or just sign up / log in / purchase `
            + `our plan for lot more ${moreNoun}.`;
    }
    if (isPremium) {
        return `You've reached the max limit of ${limit} ${longNoun} today. `
            + `Take another ${limit} ${shortNoun} tomorrow.`;
    }
    return `You've reached the max limit of ${limit} ${longNoun} today. `
        + `Take another ${limit} ${shortNoun} tomorrow, or purchase / upgrade our plan for more ${moreNoun}.`;
}
